import { getBestBetweenTwoPromos, sortPromos } from '../sort-promos'
import { WcsUser } from '../wcs/user'

export class EarlyAccessModule {
  isInvitationTooltipConfigured(): boolean {
    const invitationTooltip = this.getInvitationTooltip()
    const invitationTooltipWithoutLineBreaks = invitationTooltip?.replace(/\r?\n|\r/g, '')
    const invitationTooltipWithoutWhitespaces = invitationTooltipWithoutLineBreaks?.replace(
      /\s/g,
      ''
    )
    const result = !!invitationTooltipWithoutWhitespaces?.length
    return result
  }

  private sanitizeTooltip = (tooltipId: string) => {
    const invitationTooltip = document.getElementById(tooltipId)
    const sanitizedInvitationTooltip = invitationTooltip?.innerHTML?.replace(/<!--[^>]*-->/g, '')
    return sanitizedInvitationTooltip
  }

  getInvitationTooltip = () => {
    return this.sanitizeTooltip('cmsContentRoxPanelTooltip')
  }

  getEligibleTooltip = () => {
    return this.sanitizeTooltip('cmsContentRoxPanelTooltipEarlyAccess')
  }

  getEvents = () => {
    return {
      EARLY_ACCESS_ELIGIBILITY_CHANGED: 'earlyAccessEligiblility',
    }
  }

  isEligible = (): boolean => {
    const isEligible = WcsUser.isEarlyAccessActivityInUserClusterCookie()
    return isEligible
  }

  getEarlyAccessDiscounts = (_selectedFrame: any, _selectedPackages: any, _content: any) => {
    return new Promise(function (resolve) {
      for (let i = 0; i < _selectedPackages.length; i++) {
        const lensPromotions = _selectedPackages[i].lensPackage.priceArray
        const framePromotions = _selectedPackages[i].framePackage.priceArray

        const sortedLensPromotions = sortPromos(lensPromotions)
        const bestLensPromotions = getBestBetweenTwoPromos(sortedLensPromotions)

        const sortedFramePromotions = sortPromos(framePromotions)
        const bestFramePromotions = getBestBetweenTwoPromos(sortedFramePromotions)

        const lensDiscountedPrice = bestFramePromotions.price
        const frameDiscountedPrice = bestLensPromotions.price

        _selectedPackages[i].lensPackage.offerPrice = lensDiscountedPrice
        _selectedPackages[i].framePackage.offerPrice = frameDiscountedPrice
      }
      resolve({
        packages: _selectedPackages,
        content: _content,
      })
    })
  }
}
